import { Engine } from 'excalibur';
import { Menu } from './Menu';
import { hideUi } from './hideUi';
import { showUiTask } from './showUiTask';

export const showMenu = <T extends string>({
    options,
    engine,
}: {
    options: Array<[text: string, value: T]>;
    engine: Engine;
}): Promise<T> => {
    return new Promise<T>((resolve) => {
        const select = (option: T) => {
            hideUi();
            resolve(option);
        };
        showUiTask(Menu, { options, select, engine });
    });
};
